import PropTypes from 'prop-types';
import { Icon, ButtonTooltip } from '@evertrue/et-components';

const TaskActionsCell = ({ task, user, onAddToCalendar, onDelete }) => {
  if (!task) return null;

  const { status, owner_user_id, creator_user_id } = task;
  const isOwnerOrCreator = owner_user_id === user.id || creator_user_id === user.id;

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', width: '70%' }}>
      {/* Add to Calendar Button */}
      {status === 'PAUSED' ? (
        <ButtonTooltip
          children={'Add to calendar is disabled because this task is currently paused'}
          contentPadding={'4px 8px'}
          trigger={<Icon icon="add-task-table" iconKit="gt2" style={{ color: 'grey' }} />}
        />
      ) : isOwnerOrCreator ? (
        <ButtonTooltip
          children="Add to Calendar"
          contentPadding={'4px 8px'}
          trigger={
            <Icon
              icon="add-task-table"
              iconKit="gt2"
              onClick={() => onAddToCalendar(task)}
              style={{ color: '#007C9E' }}
              onKeyUp={() => onAddToCalendar(task)}
              isReachable={true}
            />
          }
        />
      ) : (
        <ButtonTooltip
          children={'Add to calendar is disabled because you are not the owner or creator of this task'}
          contentPadding={'4px 8px'}
          trigger={<Icon icon="add-task-table" iconKit="gt2" style={{ color: 'grey' }} />}
        />
      )}

      {/* Delete Button */}
      {status === 'PAUSED' ? (
        <ButtonTooltip
          children={'Delete task is disabled because task is currently paused'}
          contentPadding={'4px 8px'}
          trigger={<Icon icon="trash" style={{ color: 'grey' }} />}
        />
      ) : isOwnerOrCreator ? (
        <ButtonTooltip
          children="Delete"
          contentPadding={'4px 8px'}
          trigger={
            <Icon icon="trash" onClick={() => onDelete(task)} isReachable={true} onKeyUp={() => onDelete(task)} />
          }
        />
      ) : (
        <ButtonTooltip
          children="Delete option is disabled because you are not the owner of this task"
          contentPadding={'4px 8px'}
          trigger={<Icon icon="trash" style={{ color: 'grey' }} />}
        />
      )}
    </div>
  );
};

TaskActionsCell.propTypes = {
  task: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onAddToCalendar: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default TaskActionsCell;
